// Отступ для трансформа дескрипшена, чтобы он совпадал с кнопкой
export const TEXT_INDENTION = 45;

// Обратный отступ для трансформа дескрипшена, чтобы он совпадал с кнопкой
export const RETURN_TEXT_INDENTION = 21;

// Отступ от верха карточки до максимальной высоты отерытого дескрипшена
export const DESCRIPTION_INDENTION = 200;

// Отступ для трансформа кнопки, чтобы она оставалась статичной
export const BUTTON_INDENTION = 57;

// Обратный отступ для трансформа кнопки, чтобы она оставалась статичной
export const REVERSE_BUTTON_INDENTION = 33;

// Коефициент скорости анимации, чтобы она зависила от высоты диекрипшена
export const TRANSITION_TIMING_KOEF = 35;

// Стандартная высота дескрипшина, чтобы первая анимация начиналась снизу
export const DEFAULT_DESCRIPTION_HEIGHT = 500;

const BUTTONS_WIDTH = 160;

const BUSINESS_LOGO_WIDTH = 32;

const COMMON_PADDING = 16;

const SUBSCRIBE_LOGO_WIDTH = 48;

//Минимальный отступ между кнопками подписки и лайка, который мы хотим получить при сварачивании бизнес нейма
const WISH_OFFSET_BETWEN_BUTTONS = 16;

// TODO: Выпилить этот подход в таске с товарами
export const TOP_WIDTH_WITHOUT_BUSINESS_NAME =
    BUTTONS_WIDTH +
    BUSINESS_LOGO_WIDTH +
    COMMON_PADDING +
    SUBSCRIBE_LOGO_WIDTH +
    WISH_OFFSET_BETWEN_BUTTONS;
